/* DSL FAQ search filter — filter <details> elements by query */
(function(){
  var search = document.querySelector("[data-faq-search]");
  if (!search) return;
  var entries = document.querySelectorAll("[data-faq-entry]");
  search.addEventListener("input", function(){
    var q = search.value.toLowerCase().trim();
    entries.forEach(function(e){
      var txt = e.textContent.toLowerCase();
      e.hidden = q && txt.indexOf(q) === -1;
    });
  });
})();